import { configuration, dialog } from 'app/utils';
import { API, APIClient } from 'app/utils/client';
import i18n from 'app/i18n';
import { ICredentials, IResponse, ISession } from 'app/models';

const { CLIENT_SECRET } = configuration;

export class AuthService {
  public constructor(
    private client: APIClient,
    private path: string,
  ) { }

  private async intercept<T>(promise: Promise<IResponse<T>>): Promise<IResponse<T>> {
    return promise.then((response) => {
      const { success, errors } = response;
      if (!success) errors?.forEach(({ code, message }) => {
        dialog.toast({ severity: 'error', title: i18n.t(`app.errors.${code}`), message });
      });

      return response;
    });
  }

  public async signin(credentials: ICredentials) {
    return this.intercept(this.client.post<IResponse<ISession>>(`${this.path}/signin`, { ...credentials, secret: CLIENT_SECRET }));
  }

  public async refresh(token: string) {
    return this.intercept(this.client.post<IResponse<ISession>>(`${this.path}/refresh`, { token, secret: CLIENT_SECRET }));
  }

  public async signout() {
    return this.intercept(this.client.post<IResponse<void>>(`${this.path}/signout`, {}));
  }
}

const instance = new AuthService(API, 'v1');
export default instance;
